import { httpPostObservable } from './utils';

const api = {
  consumableSales: (url, body) => httpPostObservable(url, body),
};

export default api;
